import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-496778ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-tela-conteudo" }
const _hoisted_5 = { class: "ss-card ss-card-space" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESA")
], -1))
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Analisar", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "ant-row ss-alinhar-centro" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_selecionar_periodo_movimento = _resolveComponent("selecionar-periodo-movimento")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_recurso_movimento = _resolveComponent("selecionar-recurso-movimento")!
  const _component_selecionar_estoque = _resolveComponent("selecionar-estoque")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_totalizador = _resolveComponent("totalizador")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_recebimento_mercadorias = _resolveComponent("recebimento-mercadorias")!
  const _component_venda_modal = _resolveComponent("venda-modal")!
  const _component_OrdemProducaoModal = _resolveComponent("OrdemProducaoModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: "MOVIMENTACAO_ESTOQUE",
          tituloRecurso: "Movimentações de Estoque",
          exibirAtalhosTela: true,
          exibirHistoricoTela: false,
          empresasSelecionadas: [_ctx.state.codigoEmpresa]
        }, null, 8, ["empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_selecionar_empresa, {
                  codigoSelecionado: _ctx.state.codigoEmpresa,
                  "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.codigoEmpresa) = $event)),
                  onChange: _ctx.atualizarSelecaoEmpresas
                }, null, 8, ["codigoSelecionado", "onChange"])
              ])
            ]),
            _createVNode(_component_a_form, {
              class: "ss-alinhar-texto-esquerda",
              layout: "vertical"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_card, { titulo: "FILTROS" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", {
                            class: _normalizeClass((_ctx.state.parametrosConsulta.periodo === _ctx.EPeriodoMovimentoEstoque.Personalizado)?'ant-col ant-col-xs-24 ant-col-xl-6':'ant-col ant-col-xs-24 ant-col-xl-12')
                          }, [
                            _createVNode(_component_a_form_item, {
                              label: "Período",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_periodo_movimento, {
                                  codigoSelecionado: _ctx.state.parametrosConsulta.periodo,
                                  "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.parametrosConsulta.periodo) = $event))
                                }, null, 8, ["codigoSelecionado"])
                              ]),
                              _: 1
                            })
                          ], 2),
                          _withDirectives(_createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_a_form_item, {
                              label: " ",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data_inicial_final, {
                                  dataInicialSelecionada: _ctx.state.parametrosConsulta.dataInicial,
                                  "onUpdate:dataInicialSelecionada": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.parametrosConsulta.dataInicial) = $event)),
                                  dataFinalSelecionada: _ctx.state.parametrosConsulta.dataFinal,
                                  "onUpdate:dataFinalSelecionada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.parametrosConsulta.dataFinal) = $event))
                                }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                              ]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, (_ctx.state.parametrosConsulta.periodo === _ctx.EPeriodoMovimentoEstoque.Personalizado)]
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_a_form_item, {
                              label: "Produto",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_produto, {
                                  codigoSelecionado: _ctx.state.parametrosConsulta.codigoProdutoDefinicao,
                                  "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.parametrosConsulta.codigoProdutoDefinicao) = $event)),
                                  modoDefinicaoProduto: true,
                                  empresas: [_ctx.state.codigoEmpresa],
                                  apresentarCodigoInterno: true,
                                  placeholder: 'Digite o código interno, código de barras, código personalizado ou descrição do produto...',
                                  limparSelecao: false,
                                  onChange: _ctx.limparInformacoesBusca
                                }, null, 8, ["codigoSelecionado", "empresas", "placeholder", "onChange"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_a_form_item, {
                              label: "Recurso",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_recurso_movimento, {
                                  varios: true,
                                  recursosSelecionados: _ctx.state.parametrosConsulta.recursos,
                                  "onUpdate:recursosSelecionados": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.parametrosConsulta.recursos) = $event)),
                                  apenasMovimentoEstoque: true,
                                  empresas: [_ctx.state.codigoEmpresa],
                                  onChange: _ctx.limparInformacoesBusca
                                }, null, 8, ["recursosSelecionados", "empresas", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_a_form_item, {
                              label: "Estoque",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_estoque, {
                                  varios: true,
                                  codigosSelecionados: _ctx.state.parametrosConsulta.estoques,
                                  "onUpdate:codigosSelecionados": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.parametrosConsulta.estoques) = $event)),
                                  empresas: [_ctx.state.codigoEmpresa],
                                  onChange: _ctx.limparInformacoesBusca
                                }, null, 8, ["codigosSelecionados", "empresas", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_a_form_item, {
                              label: " ",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ant-btn ant-btn-primary ant-btn-block",
                                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.buscarMovimentacoes && _ctx.buscarMovimentacoes(...args)))
                                }, _hoisted_19)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card, { titulo: "MOVIMENTAÇÕES" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_a_table, {
                          key: _ctx.state.controleResultado,
                          columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                          "data-source": _ctx.state.movimentoConsulta.movimento,
                          rowKey: "codigo",
                          pagination: false,
                          loading: _ctx.gradeBase.buscandoDados,
                          size: "small"
                        }, {
                          bodyCell: _withCtx(({ column, record }) => [
                            (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.abrirModalRecurso(record))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(record.numeroDocumento), 1)
                                ], 8, _hoisted_20))
                              : _createCommentVNode("", true),
                            (column.key === 'Quantidade')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: _ctx.state.controleResultado
                                }, _toDisplayString(_ctx.montaApresentacaoQuantidade(record)), 1))
                              : (column.key === 'Data')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: _ctx.state.controleResultado
                                  }, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(record.data)), 1))
                                : _createCommentVNode("", true)
                          ]),
                          emptyText: _withCtx(() => [
                            _createVNode(_component_mensagem_sem_dados, {
                              resultadoPesquisa: true,
                              mensagem: _ctx.preparaMensagemGrade()
                            }, null, 8, ["mensagem"])
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source", "loading"]))
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_totalizador, {
                          titulo: "Saldo Inicial",
                          valor: _ctx.state.saldoInicial,
                          casasDecimais: _ctx.state.casasDecimaisTotalizadores,
                          monetario: false
                        }, null, 8, ["valor", "casasDecimais"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_totalizador, {
                          titulo: "Total de Entradas",
                          valor: _ctx.state.totalEntradas,
                          casasDecimais: _ctx.state.casasDecimaisTotalizadores,
                          monetario: false
                        }, null, 8, ["valor", "casasDecimais"])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_totalizador, {
                          titulo: "Total de Saídas",
                          valor: _ctx.state.totalSaidas,
                          casasDecimais: _ctx.state.casasDecimaisTotalizadores,
                          monetario: false
                        }, null, 8, ["valor", "casasDecimais"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_totalizador, {
                          titulo: "Saldo Final",
                          valor: _ctx.state.saldoFinal,
                          casasDecimais: _ctx.state.casasDecimaisTotalizadores,
                          monetario: false
                        }, null, 8, ["valor", "casasDecimais"])
                      ])
                    ], 512), [
                      [_vShow, (!_ctx.gradeBase.buscandoDados)]
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_recebimento_mercadorias, {
      operacao: _ctx.state.operacaoLancamento,
      origem: _ctx.EOrigemRecebimentoMercadoria.MovimentacaoEstoque,
      visivel: _ctx.state.showRecebimentoMercadoriaModal,
      "onUpdate:visivel": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.showRecebimentoMercadoriaModal) = $event)),
      onConfirmacao: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onRecebimentoMercadoriaModalClose())),
      recebimentoMercadoriaImportacao: _ctx.state.recebimentoMercadoriaImportacao
    }, null, 8, ["operacao", "origem", "visivel", "recebimentoMercadoriaImportacao"]),
    _createVNode(_component_venda_modal, {
      visivel: _ctx.state.showVendaModal,
      "onUpdate:visivel": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.showVendaModal) = $event)),
      codigoVenda: _ctx.state.currentVendaId,
      onConfirmacao: _ctx.onVendaModalClose
    }, null, 8, ["visivel", "codigoVenda", "onConfirmacao"]),
    _createVNode(_component_OrdemProducaoModal, {
      operacao: _ctx.state.operacaoLancamento,
      visivel: _ctx.state.showOrdemProducaoModal,
      "onUpdate:visivel": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.showOrdemProducaoModal) = $event)),
      codigoOrdemProducao: _ctx.state.currentOrdemProducaoId,
      empresa: _ctx.state.codigoEmpresa,
      onConfirmacao: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onOrdemProducaoModalClose()))
    }, null, 8, ["operacao", "visivel", "codigoOrdemProducao", "empresa"])
  ]))
}